import { h, Component } from 'preact';

export default class About extends Component {
	render() {
		return (
      <section class="Content">
				<div class="Container">
					<div class="Title center margin60">
						<span class="text">About</span>
					</div>
					<p>
					My name is Sam Corin and I am a full Stack Web Application Developer, currently living in Tokyo, Japan.
					I am both driven and self-motivated, and I am constantly experimenting with new technologies and techniques, specializing in highly performant user interface development and design.
					</p>

				</div>
      </section>
		);
	}
}



// WEBPACK FOOTER //
// ./components/about/index.js